/**
 * 游戏专区通用mixins
 */

import * as enums from "../../store/enums"
import * as reportDict from "../../constants/report-dictonary"
import * as gameProps from "@api/gameProps"
import * as mutationTypes from "../../store/mutation-types"
import * as storeConfigApi from "@api/store-config"
import * as ua from "@utils/ua"
import * as url from "@utils/url"
import * as helper from "@utils/helper"
import { mapActions, mapGetters } from "vuex"
import Raven from "raven-js"
import { isLOLPcGame } from "../../business/lolPc"

export default {
  computed: {
    ...mapGetters([
      "storeConfig",
      "loginState",
      "userAgent",
      "pf",
      "sandbox",
      "vmallConfig",
      "vmallConfigByItemID",
      "vmallConfigByAMSID",
      "currentItem",
      "currentItemShelfTabList",
      "currentItemShelfTabListByShelfId",
      "giftCardInfo"
    ]),
    // 是否是端游专区
    isPcGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.PC_GAME
    }
  },
  methods: {
    ...mapActions([
      "setToastMsg",
      "reportUserAction",
      "changeOfferId",
      "setCurrentItemOnly",
      "setBizDetailOnly",
      "setProvideAccountType",
      "setGameCoinIcon",
      "setGameCoinUnit",
      "setRechargeEnable",
      "reportAndJump",
      "getGiftCardInfo"
    ]),

    /**
     * 路由返回前一级
     */
    historyBack() {
      this.$router.go(-1)
    },
    /**
     * 前往道具详情页
     * @param {*} prop
     */
    goToPropDetail({
      prop,
      pfStructure = "",
      reportIformat = "",
      extendObj = {},
      routeQuery = "",
      resultInfo = {},
      reportPfStructure = ""
    }) {
      if (gameProps.isExperienceCard(prop) && gameProps.checkCardActivityValid(prop)) {
        // 如果是体验卡的话，需要跳转到对应的道具详情页
        prop = this.vmallConfigByItemID[prop.itemExtend.LinkID]
      }
      if (gameProps.isOutLinkGoods(prop)) {
        // 如果外链道具配置的是商店内路由
        if (helper.checkIfIsInnerUrl(prop.itemExtend.Link)) {
          //   如果是商店内部地址
          let hash = helper.getInnerRouterHash(prop.itemExtend.Link)

          if (hash) {
            this.$router.push({
              path: hash,
              query: {
                pfStructure: pfStructure
              }
            })

            this.reportUserAction({
              iformat: reportIformat ? reportIformat : `${reportDict.CLICK.SERVICEZONE_GOODS_LIST}`,
              pfStructure: pfStructure,
              resultInfo: resultInfo
            })
          }
        } else {
          // 如果是外链物品，上报并跳转
          this.reportAndJump({
            target: prop.itemExtend.Link,
            iformat: reportIformat ? reportIformat : `${reportDict.CLICK.SERVICEZONE_GOODS_LIST}`,
            resultInfo: {
              productId: prop.itemExtend.AMSID,
              busId: `${this.$route.params.bizgroupid}_${this.$route.params.bizid}`
            }
          })
        }

        return
      }

      let groupId = (extendObj && extendObj.bizgroupid) || this.$route.params.bizgroupid
      let bizid = (extendObj && extendObj.bizid) || this.$route.params.bizid
      let goodsId = (prop.itemExtend && prop.itemExtend.AMSID) || ""

      // 当前仅针对 LOL 使用 goodsId
      if (isLOLPcGame(this.currentItem.busId)) {
        goodsId = prop.goodsId || ""
      }

      this.$router.push({
        path: `/detail/${groupId}/biz/${bizid}/goods/${goodsId}`,
        query: {
          pfStructure: pfStructure,
          ...routeQuery
        }
      })
      if (reportIformat) {
        this.reportUserAction({
          iformat: reportIformat,
          pfStructure: reportPfStructure || "",
          resultInfo: {
            ...resultInfo,
            busId: `${groupId}_${bizid}`,
            productId: goodsId
          }
        })
      }
    },

    /**
     * 专区切换 Tab 使用
     * @param {*} linkTabId
     */
    goToOtherTab(linkTabId) {
      let linkTabIndex = 0
      try {
        // 切换tab后，让tab移动到可见范围内
        this.currentItemShelfTabList.forEach((tabShelfItem, index) => {
          if (tabShelfItem.itemId == linkTabId) {
            linkTabIndex = index
          }
        })
        document.getElementById("serviceZoneTab").scrollLeft = document.getElementById("serviceZoneTabItem" + linkTabIndex).offsetLeft - 110
      } catch (error) {
        console.log(error)
      }
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          zoneTabId: linkTabId,
          pfStructure: "zoneHome"
        }
      })
      this.reportUserAction({
        iformat: `${reportDict.CLICK.SERVICEZONE_MORE_INNERTAB}`,
        resultInfo: { zoneTabIndex: linkTabIndex, linkTabId }
      })
    },
    /**
     * 其它页面回到专区页指定Tab
     * @param {*} tabShelfId 指定tab的Id
     */
    goToDesignatedTab({ pfStructure = "", iformat, tabShelfId }) {
      let $router = this.$router
      // if (top !== self) {
      //   $router = parent._$router
      // }
      $router.push({
        path: `/order/${this.currentItem.groupId}/biz/${this.currentItem.busId}`,
        query: {
          serviceZone: 1,
          isFromShop: 1,
          zoneTabId: tabShelfId || 0,
          pfStructure: pfStructure
        }
      })

      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 500)

      if (iformat) {
        this.reportUserAction({
          iformat: iformat,
          resultInfo: { zoneTabIndex: tabShelfId }
        })
      }
    },
    /**
     * 从store-config读取业务配置，并设置currentItem
     * @param {*} bizgroupid
     * @param {*} bizid
     */
    getCurrentBizDetail({ bizgroupid, bizid }) {
      return Promise.resolve().then(() => {
        let config = this.storeConfig.itemList //获取微信店数据列表

        let bizgroup = config.filter(bizItem => bizItem.groupId == bizgroupid)[0] //获取业务组
        if (!bizgroup) {
          this.reportUserAction({
            iformat: reportDict.PAGE_VIEW.UNDEFINED_BIZ,
            resultInfo: document.referrer
          })
          throw new Error("未定义的业务")
        }

        this.$store.commit(mutationTypes.SET_BIZ_DETAIL, bizgroup)

        let defaultBiz
        if (bizid) {
          // 路由里面指定了具体业务id的
          defaultBiz = bizgroup.busList.filter(item => item.busId == bizid)[0]
          if (!defaultBiz) {
            this.reportUserAction({
              iformat: reportDict.PAGE_VIEW.UNDEFINED_BIZ,
              resultInfo: document.referrer
            })
            throw new Error("未定义的商品")
          }
        } else {
          if (bizgroup.defaultChildrenBusId) {
            //获取默认展示的业务项
            defaultBiz = bizgroup.busList.filter(item => item.busId == bizgroup.defaultChildrenBusId)[0]
          } else {
            defaultBiz = bizgroup.busList[0] //否则取第一项
          }
        }

        // 设置当前业务的商店配置currentItem(modified by seven,这里应该尽可能早设置)
        this.setCurrentItemOnly(defaultBiz)
        this.setBizDetailOnly(bizgroup)

        let userAgent = ua.getUserAgent()
        let accountType
        if (this.loginState.sessionId == "uin" || ["kp_actoken", "kp_accesstoken"].indexOf(this.loginState.sessionType) > -1) {
          accountType = enums.ACCOUNT_TYPE.QQ.toLowerCase()
        } else if (defaultBiz.default_account) {
          accountType = defaultBiz.default_account.toLowerCase()
        }
        let system = userAgent.android ? "android" : "ios"

        if (defaultBiz.categoryId == enums.BUSINESS_TYPE.PC_GAME) {
          if (defaultBiz.offerId) this.changeOfferId(defaultBiz.offerId)
          this.setProvideAccountType(enums.ACCOUNT_TYPE.QQ)
          this.setRechargeEnable(true)
        } else if (defaultBiz.categoryId == enums.BUSINESS_TYPE.MOBILE_GAME) {
          if (defaultBiz[system] && defaultBiz[system][accountType] && defaultBiz[system][accountType].offerid) {
            this.changeOfferId(defaultBiz[system][accountType].offerid)
          }
          this.setProvideAccountType(enums.ACCOUNT_TYPE[accountType.toUpperCase()])
          if (
            defaultBiz[system] &&
            defaultBiz[system][accountType] &&
            defaultBiz[system][accountType].status == enums.PRODUCT_STATUS.ONLINE
          ) {
            this.setRechargeEnable(true)
          }
        }

        Raven.captureBreadcrumb({
          message: "get-biz-detail",
          category: "detail",
          data: {
            currentItem: this.currentItem
          }
        })
      })
    },

    /**
     * 获取道具关联实物内容
     * @param {*} params
     */
    getRealGoodsConfig(params) {
      return new Promise((resolve, reject) => {
        if (params.url) {
          storeConfigApi
            .getConfigFromPayUrl({
              configUrl: params.url.trim(),
              configUrlParam: {}
            })
            .then(config => {
              let realGoodsMap = {}
              if (config && config.itemList && config.itemList.length) {
                config.itemList.forEach(item => {
                  realGoodsMap[item.goodsId] = item.realGoods
                })
              }
              resolve(realGoodsMap)
            })
            .catch(e => {
              Raven.captureException(new Error("get-realGoods-catch-error"), {
                tags: { type: "get-realGoods-catch-error" },
                extra: {
                  e,
                  url: params.url.trim()
                }
              })
              reject(e)
            })
        } else {
          reject("配置链接缺失")
        }
      })
    },

    /**
     * 广告位---跳转到活动页
     * @param {*} index
     */
    jumpToActivityPage({ activityConfig, index, iformat, pfStructure, routeQuery = {} }) {
      if (!activityConfig[index]) return
      let activityItem = activityConfig[index]
      if (typeof activityItem.link == "object") {
        let { groupId, busId, goodsId } = activityItem.link
        this.$router.push({
          path: `/detail/${groupId}/biz/${busId}/goods/${goodsId}`,
          query: {
            pfStructure: `${pfStructure}_${index}`,
            ...routeQuery
          }
        })
        this.reportUserAction({
          iformat: iformat,
          pfStructure: this.$route.query.pfStructure,
          resultInfo: {
            index,
            productId: goodsId,
            busId: `${groupId}_${busId}`
          }
        })
      } else if (helper.checkIfIsInnerUrl(activityItem.link)) {
        let hash = helper.getInnerRouterHash(activityItem.link)

        if (hash) {
          this.$router.push({
            path: hash,
            query: {
              pfStructure: `${pfStructure}_${index}`
            }
          })

          this.reportUserAction({
            iformat: iformat,
            pfStructure: this.$route.query.pfStructure,
            resultInfo: {
              index
            }
          })
        }
      } else {
        // 外链
        this.reportAndJump({
          target: activityItem.link,
          iformat: iformat,
          resultInfo: { index, target: activityItem.link }
        })
      }
    },

    /**
     * 外部带货场景跳转活动页
     * @param {*} link
     */
    jumpOuterLinkWithLogin({ link, iformat, resultInfo }) {
      // 所有场景（微视、小程序、快手）都从登录态取
      let loginState = helper.getLoginState(this.loginState)

      let addParams = {
        tx_chan_type: url.getParam("tx_chan_type")
      }

      // 当快手场景，可能会发快币，所以需要指定发放快手号。如果是其他场景无需传递指定抽中号，抽奖号即抽中号
      if (addParams.tx_chan_type == "ks") {
        addParams.tx_buyer_id = url.getParam("tx_buyer_id")
      }

      // 微信内无需传递登录态给抽奖页，因为抽奖页在微信内会自行获取登录态，如果传递，会导致传递的登录态失效，页面无法抽奖
      if (loginState && loginState.openid && (!this.userAgent.weixin || this.userAgent.weixinminiprogram)) {
        addParams = {
          ...addParams,
          sessionid: loginState.session_id,
          sessiontype: loginState.session_type,
          openid: loginState.openid,
          openkey: loginState.openkey
        }

        if (loginState.wx_appid) addParams.wx_appid = loginState.wx_appid
        if (loginState.qq_appid) addParams.qq_appid = loginState.qq_appid
      }

      link = url.addGetParam(addParams, link)
      if (iformat) {
        this.reportAndJump({
          target: link,
          iformat: iformat,
          resultInfo: resultInfo
        })
      }
    },

    isWzry(busId) {
      return busId * 1 === 2
    },

    /**
     * 通过goodId来获得道具信息
     * 王者用的是itemid
     * 非王者用的是amsid
     * 此处为了避免多处调用封一个函数
     */
    getPropByGoodId(busId, goodId) {
      if (this.isWzry(busId)) {
        return this.vmallConfigByItemID[goodId]
      } else {
        return this.vmallConfigByAMSID[goodId]
      }
    },

    /**
     * 获取包含预售的道具
     */
    getVmallConfigByItemIDIncludePreOrder(itemKey) {
      let vmallConfigByItemID = {}
      if (this.vmallConfig && this.vmallConfig[itemKey]) {
        let vmallConfig = Object.assign({}, this.vmallConfig[itemKey])
        // 不在线上的道具在vmallConfig阶段已过滤
        Object.keys(vmallConfig).forEach(AMSID => {
          try {
            let goods = vmallConfig[AMSID]
            // goods.goodsId lol没有itemId
            let itemId = itemKey === "73_93" ? goods.goodsId : goods.itemId
            // 针对预售道具，如果对应正式道具开始正式售卖（在线上且不是预上线状态）显示正式道具；否则认为是预售期显示预售道具。
            // 如果预售道具提前一小时停止售卖，这一小时会显示预售道具，按钮为【预售已结束】

            if (
              vmallConfigByItemID[itemId] &&
              vmallConfigByItemID[itemId].goodsExtend &&
              vmallConfigByItemID[itemId].goodsExtend.ActivityType == "preOrder"
            ) {
              // 如果itemId已存在，且value为预售道具，则不用正式道具覆盖它
              return
            }

            if (goods.goodsExtend && goods.goodsExtend.ActivityType === "preOrder") {
              // 如果预售对应正式道具已上线，重定向到正式道具，预上线不跳转
              if (goods.goodsExtend && goods.goodsExtend.CommonAMSID) {
                let commonGood = vmallConfig[goods.goodsExtend.CommonAMSID]
                if (commonGood && !gameProps.isOffline(commonGood) && !gameProps.isPreview(commonGood)) {
                  vmallConfigByItemID[itemId] = commonGood
                  return
                }
              }
            }

            vmallConfigByItemID[itemId] = goods
          } catch (error) {
            console.log(error)
          }
        })
      }
      return vmallConfigByItemID
    },

    // 排名
    rankingNum(rankItem, goodsItem, idx) {
      if (rankItem.rankType && rankItem.rankType == "rating") {
        let list = helper.uniqueArr(
          rankItem.list.map(score => {
            return score.avg_score
          })
        )
        return list.indexOf(goodsItem.avg_score, 0) + 1
      }
      return idx + 1
    },
    // 跳到礼品卡tab页
    async goToGiftCardTab({ amsId = "" }) {
      if (!this.giftCardInfo) {
        await this.getGiftCardInfo()
      }
      let link = this.giftCardInfo[amsId]?.useUrl || ""
      // 跳兑换列表页，暂时写死跳专区tab，后续跳统一兑换列表页
      if (helper.checkIfIsInnerUrl(link)) {
        //   如果是商店内部地址
        let hash = helper.getInnerRouterHash(link)

        if (hash) {
          this.$router.push({
            path: hash,
            query: {
              pfStructure: this.$route.query.pfStructure
            }
          })
        }
      } else {
        // 外链
        this.reportAndJump({
          target: link
        })
      }
    }
  }
}
